import { render } from "./PEmojiPicker.vue?vue&type=template&id=002004dd&scoped=true"
import script from "./PEmojiPicker.vue?vue&type=script&lang=js"
export * from "./PEmojiPicker.vue?vue&type=script&lang=js"

import "./PEmojiPicker.vue?vue&type=style&index=0&id=002004dd&scoped=true&lang=css"

import exportComponent from "/var/www/html/pipit-phase5-demo/Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002004dd"]])

export default __exports__